const getLocationKey = (role, locationId) => `${role}:${String(locationId)}`

const indexOffersByLocation = mapOffers => {
  const index = new Map()
  mapOffers.forEach(mapOffer => {
    const source = mapOffer.offer || {}
    const locations = {
      origin: mapOffer.from && mapOffer.from.location,
      destination: mapOffer.to && mapOffer.to.location,
      return: source.returnLocation || (source.raw && source.raw.returnLocation)
    }
    Object.entries(locations).forEach(([role, location]) => {
      if (!location || location.id == null) return
      const key = getLocationKey(role, location.id)
      if (!index.has(key)) index.set(key, new Set())
      index.get(key).add(mapOffer)
    })
  })
  return index
}

const getGroupOffers = (group, index) => {
  const offers = new Set()
  group.locationIds.forEach(locationId => {
    const locationOffers = index.get(getLocationKey(group.role, locationId))
    if (locationOffers) locationOffers.forEach(offer => offers.add(offer))
  })
  return Array.from(offers)
}

// Aggregate map points have no listing dates. Recount only locations for which
// offers have actually been loaded, keeping unopened locations selectable.
export const filterLoadedMapLocationGroups = (
  locationGroups,
  loadedOffers,
  matchingOffers
) => {
  const loadedIndex = indexOffersByLocation(loadedOffers)
  const matchingIndex = indexOffersByLocation(matchingOffers)
  return locationGroups.reduce((groups, group) => {
    if (getGroupOffers(group, loadedIndex).length === 0) {
      return groups.concat(group)
    }
    const offers = getGroupOffers(group, matchingIndex)
    if (offers.length === 0) return groups
    return groups.concat({
      ...group,
      offers,
      offersCount: offers.length,
      points: (group.points || []).map(point => {
        const pointOffers = matchingIndex.get(
          getLocationKey(group.role, point.locationId)
        )
        return { ...point, offersCount: pointOffers ? pointOffers.size : 0 }
      })
    })
  }, [])
}
